<template>
  <div class="set-font pt-6">
    <div class="d-flex justify-space-between text-color font-weight-bold">
      <div>Available:</div>
      <div>{{ amountHint }}</div>
    </div>

    <!-- Amount Section -->
    <amount-input
      v-model="amount"
      label="Deposit Amount"
      :maxVal="maxVal"
      :hint="amountHint"
      hideDetails
      :focus="focus"
    ></amount-input>

    <!-- Rates Section -->
    <!-- <deposit-rate-section :depositAPY="depositAPY" :rewardAPY="rewardAPY" /> -->

    <!-- Borrow Limit Section -->
    <borrow-limit-section :market="value" />

    <connect-wallet></connect-wallet>

    <div class="mt-4">
      <v-alert v-if="actionBtnDisabled && actionBtnDisabled !== 'empty'" type="warning" dense>{{ actionBtnDisabled }}</v-alert>
    </div>

    <!-- Deposit Btn -->
    <div :class="[actionBtnDisabled ? 'mt-4' : 'mt-8']">
      <v-btn color="accent" :disabled="!!actionBtnDisabled" depressed large block @click="deposit(amount)">
        Deposit {{ value.underlySymbol }}
      </v-btn>
    </div>

    <section class="mt-2" v-if="destChains.length">
      <v-divider class="my-2"></v-divider>
      <div class="text-center">Deposit by Omni</div>
      <custom-select
        label="Select Dest Chain"
        :value="currentDestChain"
        :options="destChains"
        @selected="destChainSelected"
      />
      <div>Receive：{{ destChainQuoteReceiveAmount }} {{ value.underlySymbol }}</div>

      <div :class="[actionBtnDisabled ? 'mt-4' : 'mt-8']">
        <v-btn color="accent" :disabled="!!actionBtnDisabled" depressed large block @click="depositByOmni(amount)">
          Deposit {{ value.underlySymbol }} to {{ currentDestChain.name }}
        </v-btn>
      </div>
    </section>
  </div>
</template>
<script>
import { BigNumber } from 'bignumber.js'
import { mapActions, mapState } from 'vuex'
import DepositRateSection from './depositRateSection.vue'
import BorrowLimitSection from './borrowLimitSection.vue'
import { formatNumReadable1 } from '@/utils'
import { getSupportNetworksById } from '../../../constants'
import Sumer from '@meterio/sumer-js'
import { formatUnits } from 'viem'

export default {
  name: 'DepositTab',
  components: { DepositRateSection, BorrowLimitSection },
  props: {
    value: {
      type: Object,
      require: true,
    },
    focus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      amount: '',
      depositLoading: false,
      enableLoading: false,

      currentDestChain: {},
      destChains: [],
      destChainQuoteReceiveAmount: 0
    }
  },
  created() {
    if (this.value && this.currentNetwork && this.currentNetwork.omni) {
      const allChains = getSupportNetworksById(this.currentNetwork.networkId)
      console.log('all chains', allChains)
      const supportOmniChains = allChains
        .filter(c => c.omni && c.omni.assets.includes(this.value.underlySymbol))
        .filter(c => c.networkId !== this.currentNetwork.networkId)
      this.destChains = supportOmniChains
      this.currentDestChain = supportOmniChains[0]
    }
  },
  computed: {
    ...mapState('wallet', ['currentNetwork']),
    actionBtnDisabled() {
      if (this.amount.trim() === '') {
        return 'empty'
      } else if (Number.isNaN(Number(this.amount))) {
        return 'Invalid balance'
      } else if (Number(this.amount) * `1e${this.value.underlyDecimals}` <= 1000) {
        return `Minimum desposit needs to be greater than ${new BigNumber(1000).div(`1e${this.value.underlyDecimals}`).toFixed()}`
      } else if (Number(this.amount) > Number(this.value.underlyBalance)) {
        return 'Insuffient balance'
      } else if (this.value.totalDeposit.plus(this.amount).gt(this.value.depositCap)) {
        return 'Deposit cap reached'
      }
      return false
    },
    amountHint() {
      return `${formatNumReadable1(this.value.underlyBalance, 4, 1)}`
    },
    maxVal() {
      return new BigNumber(String(this.value.underlyBalance)).toFixed()
    },
    
  },
  watch: {
    amount() {
      this.getDestChainQuoteReceiveAmount()
    },
    currentDestChain() {
      this.getDestChainQuoteReceiveAmount()
    }
  },
  methods: {
    ...mapActions({
      approve: 'tx/approve',
      supply: 'tx/supply',
      depositToDestByOmni: 'tx/depositByOmni',
      quoteDepositToDestByOmni: 'tx/quoteDepositByOmni'
    }),
    async deposit(amount) {
      const params = {
        underlySymbol: this.value.underlySymbol,
        sdrTokenAddress: this.value.sdrTokenAddress,
        amount,
      }
      await this.supply(params)
    },
    destChainSelected(data) {
      this.currentDestChain = data
    },
    transferTokenSelected(data) {
      this.currentTransferToken = data
    },
    depositByOmni(amount) {
      this.depositToDestByOmni({
        amount,
        destChain: this.currentDestChain,
        symbol: this.value.underlySymbol
      })
    },
    async getDestChainQuoteReceiveAmount() {
      if (this.amount && this.currentDestChain.name) {
        const quoteData = await this.quoteDepositToDestByOmni({
          amount: this.amount,
          destChain: this.currentDestChain,
          symbol: this.value.underlySymbol
        })

        this.destChainQuoteReceiveAmount = formatUnits(quoteData.expense.amount, Number(this.value.underlyDecimals)).toString()
      }
    }
  },
}
</script>
